import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Typography, Container, Box, Button } from '@material-ui/core'

import useTranslate from '../../i18n/useTranslate'
import useChecklist, { Checklist } from '../../services/um/useChecklist'
import useAuthenStore from '../../stores/authen/authenStore'
import useLoading from '../../control/loading/useLoading'

import ChecklistForm from '../../component/um/settingChecklist/ChecklistForm'
import ChecklistList from '../../component/um/settingChecklist/ChecklistList'
import OrderedChecklist from '../../component/um/settingChecklist/OrderedChecklist'

function AddEditCheckList() {
    const translate = useTranslate()
    const checklistServices = useChecklist()
    const loadingHook = useLoading()
    const { state } = useLocation<{ topicID: number }>()
    const topicID = state?.topicID
    const { profile } = useAuthenStore()
    const irb = Number(profile?.irb)

    const [mode, setMode] = useState<'view' | 'order'>('view')
    const [checklistList, setChecklistList] = useState<Checklist[]>([])

    async function fetchChecklistList() {
        try {
            loadingHook.loadingOpen()
            const { result } = await checklistServices.getChecklistList(topicID, irb)
            setChecklistList(result)
        } catch (error) {
            console.error(error)
        } finally {
            loadingHook.loadingClose()
        }
    }

    function onOrdered() {
        fetchChecklistList()
        setMode('view')
    }

    useEffect(() => {
        fetchChecklistList()
    }, [])

    return (
        <Container maxWidth="lg">
            <Typography variant="h5" style={{ fontWeight: 700, marginBottom: 40 }}>
                {translate.get('UM.USERGROUP-ADD.TITLE')}
            </Typography>

            <ChecklistForm topicID={topicID} onSubmitted={fetchChecklistList} />

            {mode === 'view' ? (
                <>
                    <Box display="flex" mt={2} mb={2} justifyContent="flex-end">
                        <Button size="large" variant="outlined" color="primary" onClick={() => setMode('order')}>
                            {translate.get('BUTTON.ORDER')}
                        </Button>
                    </Box>
                    <ChecklistList topicID={topicID} checklistList={checklistList} onChange={fetchChecklistList} />
                </>
            ) : null}

            {mode === 'order' ? (
                <OrderedChecklist
                    topicID={topicID}
                    initialValues={checklistList}
                    onOrdered={onOrdered}
                    onCancel={() => setMode('view')}
                />
            ) : null}
        </Container>
    )
}

export default AddEditCheckList
